export default __webpack_public_path__ + "static/media/of_4.5274ecbe.mp3";